<script>
	// @ts-nocheck
	import { tgbot } from '$lib/store/telegrappapp';
	import { basketList } from '$lib/store/basket';
	import { basketListnew, basketId } from '$lib/store/newbasket';
	import { clickOutside } from '$lib/utils/click_outside.js';
	import { lang } from '$lib/translations/menu';
	import { page } from '$app/stores';
	import { onMount } from 'svelte';
	import { favoritesList } from '$lib/store/favorites';
	import { fade, slide, fly } from 'svelte/transition';
	import logo from '$lib/images/logo.svg';
	import Activelike from '$lib/images/activeLike.svg';
	import basket from '$lib/images/baskhead.svg';
	import favorite from '$lib/images/favoritehead.svg';
	import search from '$lib/images/searchhead.svg';
	import Lang from '$lib/components/Lang.svelte';

	import basketm from '$lib/images/basketheadm.svg';
	import favoritem from '$lib/images/favoriteheadm.svg';
	import searchm from '$lib/images/serchheadm.svg';
	import menum from '$lib/images/Menu.svg';
	import closem from '$lib/images/closemenu.svg';
	import { goto } from '$app/navigation';
	import ItemCategoryMenu from './ItemCategoryMenu.svelte';
	import LinkNav from './LinkNav.svelte';
	import PlashNav from './PlashNav.svelte';
	import Search from './Search.svelte';
	import FavoritesPage from './FavoritesPage.svelte';
	import BasketPage from './BasketPage.svelte';
	import LinkCatalog from './LinkCatalog.svelte';
	import ItemBrand from './ItemBrand.svelte';
	import MobileProfile from './MobileProfile.svelte';

	let links = [
		{
			name: lang[$page.data.host]['onaslink'],
			slug: '/about'
		},
		{
			name: lang[$page.data.host]['dostpaylink'],
			slug: '/delivery'
		},
		{
			name: lang[$page.data.host]['contactlink'],
			slug: '/contacts'
		},
		{
			name: lang[$page.data.host]['gift_cardlink'],
			slug: '/gift-card'
		}
	];
	let navClass = 'nav-noscroll';
	let lastScrollTop = 0;

	onMount(() => {
		if (localStorage.getItem('open_basket')) {
			OpenBasket = true;
		}
		const handleScroll = () => {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			if (scrollTop > lastScrollTop) {
				// прокрутка вниз
				navClass = 'nav-scroll';
			} else {
				// прокрутка вверх
				navClass = 'nav-noscroll';
			}
			lastScrollTop = scrollTop;
		};
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	});
	const handleMouseEnter = () => {
		navClass = 'nav-scroll';
	};

	const handleMouseLeave = () => {
		navClass = 'nav-noscroll';
	};
	let OpenMenu = false;
	function OnPage(link) {
		goto(link);
		OpenMenu = false;
	}
	let OpenPlash = false;
	let OpenBasket = false;
	let itemOpenPlash = null;
	function onOpenOpenPlash(item, OpenPlasValue) {
		OpenPlash = OpenPlasValue;
		itemOpenPlash = item;
	}
	let OpenSearch = false;
	let OpenFavorites = false;
	let openMenuProfile = false;
	async function LogoutUser() {
		let url = `/auth/logout`;
		const res = await fetch(url);
		setTimeout(() => {
			window.location.href = $page.url.pathname;
		}, 200);
	}
	let openMenuProfileMobile = false;
</script>

{#if OpenSearch}
	<Search bind:OpenSearch />
{/if}

{#if OpenFavorites}
	<FavoritesPage bind:OpenFavorites />
{/if}

{#if OpenBasket}
	<BasketPage bind:OpenBasket />
{/if}
<nav
	style="z-index: 20;"
	on:mouseenter={handleMouseEnter}
	on:mouseleave={handleMouseLeave}
	class:nav-scroll={navClass === 'nav-scroll'}
	class:nav-noscroll={navClass === 'nav-noscroll'}
	class="nav-app navbar lg:block hidden fixed left-0 w-full top-0 z-20"
>
	<div class="flex-col relative px-2">
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<span class="flex cursor-pointer pt-[18px] pb-[17px] justify-between items-center">
			<span />

			<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
			<img
				on:click={() => {
					location.href = '/';
				}}
				width="53"
				height="32"
				src={logo}
				alt="logo"
			/>
			<div />
		</span>
		<div class="absolute top-3 right-3">
			<Lang />
		</div>

		<div
			class="pb-[13px] relative border-t-[0.5px] pr-[21px] pl-[21px] border-custom-white-bg pt-[10px] flex justify-around"
		>
			<div class=" justify-end">
				<ul class="flex justify-end items-center">
					<LinkCatalog />
					{#each links as item}
						<li>
							<LinkNav {item} {onOpenOpenPlash} />
						</li>
					{/each}
				</ul>
			</div>
			<ul class="flex justify-around items-center">
				<li class="inline-flex justify-around items-center">
					<button
						on:click={() => {
							OpenSearch = true;
						}}
					>
						<img height="18" width="18" src={search} alt="search" />
					</button>
					<button
						on:click={() => {
							OpenFavorites = true;
						}}
						class="ml-[17px] relative"
					>
						{#if $favoritesList.length > 0}
							<img width="23" height="22" src={Activelike} alt="favorite" />
						{:else}
							<img width="22" height="22" src={favorite} alt="favorite" />
						{/if}
					</button>
					{#if !$tgbot?.initData}
						<button
							on:click={() => {
								OpenBasket = true;

								localStorage.setItem('open_basket', 1);
							}}
							class="ml-[17px] relative"
						>
							<img width="22" height="22" src={basket} alt="basket" />

							{#if $basketListnew?.order_items?.length > 0}
								<div
									class="absolute -top-3 -left-3 inline-flex pt-1 items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 rounded-full"
								>
									{$basketListnew.order_items.length}
								</div>
							{/if}
						</button>

						<button
							use:clickOutside
							on:outclick={() => (openMenuProfile = false)}
							on:click={() => {
								if (!$page.data.user) {
									goto('/auth/sign-in');
								} else {
									openMenuProfile = !openMenuProfile;
								}
							}}
							class="ml-4 relative"
						>
							<svg
								class="h-6 w-6 text-gray-200"
								viewBox="0 0 20 20"
								fill="currentColor"
								aria-hidden="true"
							>
								<path
									d="M10 8a3 3 0 100-6 3 3 0 000 6zM3.465 14.493a1.23 1.23 0 00.41 1.412A9.957 9.957 0 0010 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 00-13.074.003z"
								/>
							</svg>
							{#if openMenuProfile}
								<div
									class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
									role="menu"
									aria-orientation="vertical"
									aria-labelledby="user-menu-button"
									tabindex="-1"
								>
									<!-- Active: "bg-gray-100", Not Active: "" -->
									<a
										href="/profile"
										class="block px-4 py-2 text-sm text-gray-700"
										role="menuitem"
										tabindex="-1"
										id="user-menu-item-0">Профиль</a
									>
									<!-- svelte-ignore missing-declaration -->
									<!-- svelte-ignore a11y-click-events-have-key-events -->
									<span
										on:click={() => {
											LogoutUser();
										}}
										class="block px-4 py-2 text-sm text-gray-700"
										role="menuitem"
										tabindex="-1"
										id="user-menu-item-1">Выйти</span
									>
								</div>
							{/if}
						</button>
					{/if}
				</li>
			</ul>
		</div>
	</div>
</nav>
<!-- MOBILE -->
<!-- OpenMenu -->
{#if OpenMenu}
	<div class="overflow-hidden">
		<div
			style="z-index: 460;"
			transition:fly={{
				x: -200,
				duration: 500
			}}
			class="fixed overflow-auto open-menu left-0 w-full top-0 z-10 h-screen"
		>
			<div
				class="flex justify-between items-center border-b-[0.5px] border-custom-gray pr-[27px] pt-[20px] pl-[27px] pb-[18px]"
			>
				<div />

				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
				<img
					on:click={() => {
						goto('/');
					}}
					width="51"
					height="32"
					src={logo}
					alt="logo"
				/>

				<button
					on:click={() => {
						OpenMenu = false;
					}}
				>
					<img width="20" height="20" src={closem} alt="close" />
				</button>
			</div>

			<div
				class="flex justify-between items-center border-b-[0.5px] border-custom-gray pr-[27px] pt-[20px] pl-[27px] pb-[18px]"
			>
				<button
					on:click={() => {
						OnPage('/sale');
					}}
					class="text-2xl text-custom-white-bg"
				>
					{#if $page.data.host != 'ARM'}
						<span class="text-red-700 font-semibold">Скидки %</span>
					{:else}
						<span class="text-red-700 font-semibold">զեղչեր %</span>
					{/if}</button
				>
			</div>
			<div
				class="flex justify-between items-center border-b-[0.5px] border-custom-gray pr-[27px] pt-[20px] pl-[27px] pb-[18px]"
			>
				<button
					on:click={() => {
						OnPage('/gift-card');
					}}
					class="text-2xl text-custom-white-bg"
				>
					{lang[$page.data.host]['gift_cardlink']}</button
				>
			</div>
			<div
				class="flex justify-between items-center border-b-[0.5px] border-custom-gray pr-[27px] pt-[20px] pl-[27px] pb-[18px]"
			>
				<button
					on:click={() => {
						OnPage('/pre-order-products');
					}}
					class="text-2xl text-custom-white-bg"
				>
					<span class="text-white font-semibold">Предзаказ</span>
				</button>
			</div>
			<div
				class="flex justify-between items-center border-b-[0.5px] border-custom-gray pr-[27px] pt-[20px] pl-[27px] pb-[18px]"
			>
				<button
					on:click={() => {
						OnPage('/premium-products');
					}}
					class="text-2xl text-custom-white-bg"
				>
					<span class="text-white font-semibold">Премиум</span>
				</button>
			</div>
			<div
				class="flex justify-between items-center border-b-[0.5px] border-custom-gray pr-[27px] pt-[20px] pl-[27px] pb-[18px]"
			>
				<button
					on:click={() => {
						OnPage('/gentlemen-products');
					}}
					class="text-2xl text-custom-white-bg"
				>
					<span class="text-white font-semibold">Джентльменам</span>
				</button>
			</div>
			<ItemBrand bind:OpenMenu {OnPage} />

			{#each $page.data.manucategories as item}
				<ItemCategoryMenu bind:OpenMenu {item} {OnPage} />
			{/each}

			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<!-- svelte-ignore a11y-no-static-element-interactions -->
			<div
				on:click={() => {
					OpenMenu = false;
					goto('/auth/sign-in');
				}}
				class="flex justify-between items-center border-b-[0.5px] border-custom-gray pr-[27px] pt-[20px] pl-[27px] pb-[18px]"
			>
				<span class="text-2xl text-custom-white-bg">ЛИЧНЫЙ КАБИНЕТ</span>
				<button
					on:click={() => {
						goto('/auth/sign-in');
					}}
					class="ml-4"
				>
					<svg
						class="h-5 w-5 text-gray-300"
						viewBox="0 0 20 20"
						fill="currentColor"
						aria-hidden="true"
					>
						<path
							d="M10 8a3 3 0 100-6 3 3 0 000 6zM3.465 14.493a1.23 1.23 0 00.41 1.412A9.957 9.957 0 0010 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 00-13.074.003z"
						/>
					</svg>
				</button>
			</div>
			{#each links as item}
				<div
					class="flex justify-between items-center border-b-[0.5px] border-custom-gray pr-[27px] pt-[20px] pl-[27px] pb-[18px]"
				>
					<button
						on:click={() => {
							location.href = item.slug;
						}}
						class="text-2xl text-custom-white-bg">{item.name}</button
					>
				</div>
			{/each}
		</div>
	</div>
{:else}
	<nav
		style="z-index: 20;"
		class="nav-app lg:hidden nav-scroll pr-[23px] pl-[30px] fixed left-0 w-full top-0 z-10 block h-[60px]"
	>
		<div class="h-full w-full flex justify-between items-center">
			<button
				on:click={() => {
					OpenMenu = true;
				}}
				class="inline-flex justify-start items-center"
			>
				<img width="25" height="13" src={menum} alt="menu" />
				<span class="text-sm ml-[10px] text-custom-gray2">MENU</span>
				<!-- {#if !$page.data.user}
				<span class="text-sm ml-[10px] text-custom-gray2">MENU</span>
				{/if} -->
			</button>

			<div>
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<img
					on:click={() => {
						location.href = '/';
					}}
					width="51"
					height="32"
					src={logo}
					alt="logo"
				/>
			</div>

			<div style="min-width: 4.5em;" class="inline-flex justify-end items-center">
				<button
					on:click={() => {
						OpenFavorites = true;
					}}
					class="relative"
				>
					{#if $favoritesList.length > 0}
						<img height="16" width="21" src={Activelike} alt="favorite" />
					{:else}
						<img height="16" width="21" src={favoritem} alt="favorite" />
					{/if}
				</button>
				<div class="ml-4">
					<Lang />
				</div>

				<!-- <button
					on:click={() => {
						OpenSearch = true;
					}}
				>
					<img height="16" width="15" src={searchm} alt="search" />
				</button>
				<button
					on:click={() => {
						OpenFavorites = true;
					}}
					class="ml-[22px] relative"
				>
					{#if $favoritesList.length > 0}
						<img height="16" width="21" src={Activelike} alt="favorite" />
					{:else}
						<img height="16" width="21" src={favoritem} alt="favorite" />
					{/if}
				</button>

				<button
					on:click={() => {
						OpenBasket = true;
						localStorage.setItem('open_basket', 1);
					}}
					class="ml-[22px] relative"
				>
					<img height="16" width="19" src={basketm} alt="basket" />

					{#if $basketListnew?.order_items?.length > 0}
						<div
							class="absolute -top-2 -left-2 text-[8px] inline-flex items-center justify-center w-4 h-4 font-bold text-white bg-red-500 rounded-full"
						>
							{$basketListnew.order_items.length}
						</div>
					{/if}
				</button> -->
			</div>
		</div>
	</nav>
{/if}

<style>
	.open-menu {
		background: rgba(56, 56, 56, 0.95);
	}
	nav {
	}
	.nav-noscroll {
		transition: background 1s ease-in-out;
		background: linear-gradient(
			180deg,
			#000000 0%,
			rgba(0, 0, 0, 0.0208333) 99.98%,
			rgba(0, 0, 0, 0) 99.99%,
			rgba(0, 0, 0, 0) 100%
		);
	}
	.nav-scroll {
		transition: background 1s ease-in-out;
		background: #1b1b1b;
	}
</style>
